"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@emotion/react");
var _styles = require("./styles");
var _Image = _interopRequireDefault(require("../Image"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _Text = _interopRequireDefault(require("../Text"));
var _IconChevronLeft = _interopRequireDefault(require("../../icons/General/IconChevronLeft"));
var _IconClose = _interopRequireDefault(require("../../icons/General/IconClose"));
var _react2 = require("react");
var _Keyboard = require("../../enums/Keyboard");
var _reactAria = require("react-aria");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const ImageViewer = ({
  images,
  initialImage = 0,
  onClose
}) => {
  const theme = (0, _react.useTheme)();
  const [isZoomed, setIsZoomed] = (0, _react2.useState)(false);
  (0, _react2.useEffect)(() => {
    // Trigger close event on "escape" keydown
    const handleKeyDown = event => {
      if (event.key === _Keyboard.Key.escape) onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const hasMultipleImages = Boolean(images.length > 1);
  return (0, _jsxRuntime.jsx)("div", {
    css: _styles.styles.overlay,
    children: (0, _jsxRuntime.jsxs)("div", {
      css: _styles.styles.carousel,
      role: "dialog",
      "aria-modal": true,
      "aria-labelledby": "carousel-heading",
      children: [(0, _jsxRuntime.jsx)(_reactAria.VisuallyHidden, {
        id: "carousel-heading",
        children: "Bildevisning"
      }), (0, _jsxRuntime.jsx)(_nukaCarousel.default, {
        enableKeyboardControls: true,
        swiping: hasMultipleImages,
        dragging: hasMultipleImages,
        wrapAround: true,
        slideIndex: initialImage,
        cellSpacing: 15,
        onUserNavigation: () => setIsZoomed(false),
        renderTopRightControls: () => (0, _jsxRuntime.jsx)("button", {
          css: _styles.styles.closeBtn,
          onClick: onClose,
          "aria-label": "Lukk bildevisning",
          children: (0, _jsxRuntime.jsx)(_IconClose.default, {
            color: "white"
          })
        }),
        renderCenterRightControls: ({
          nextSlide
        }) => hasMultipleImages && (0, _jsxRuntime.jsx)("button", {
          css: _styles.styles.controlBtn('right'),
          onClick: nextSlide,
          "aria-label": "Naviger til neste bilde",
          children: (0, _jsxRuntime.jsx)(_IconChevronLeft.default, {
            size: 18,
            color: theme.btnDefaultFontColor,
            flip: true
          })
        }),
        renderCenterLeftControls: ({
          previousSlide
        }) => hasMultipleImages && (0, _jsxRuntime.jsx)("button", {
          css: _styles.styles.controlBtn('left'),
          onClick: previousSlide,
          "aria-label": "Naviger til forrige bilde",
          children: (0, _jsxRuntime.jsx)(_IconChevronLeft.default, {
            size: 18,
            color: theme.btnDefaultFontColor
          })
        }),
        renderBottomCenterControls: ({
          currentSlide
        }) => (0, _jsxRuntime.jsx)("div", {
          css: _styles.styles.pageInfo,
          children: (0, _jsxRuntime.jsxs)(_Text.default, {
            color: theme.btnDefaultFontColor,
            size: "14px",
            "aria-label": `Bilde ${currentSlide + 1} av ${images.length}`,
            children: [currentSlide + 1, " / ", images.length]
          })
        }),
        children: images.map((imageSrc, i) => (0, _jsxRuntime.jsx)("div", {
          css: [_styles.styles.imageContainer(isZoomed), process.env.NODE_ENV === "production" ? "" : ";label:ImageViewer;"],
          children: (0, _jsxRuntime.jsx)(_Image.default, {
            src: imageSrc,
            alt: `Bilde ${i + 1} av ${images.length}`,
            objectFit: "contain",
            onClick: () => setIsZoomed(!isZoomed)
          })
        }, i))
      })]
    })
  });
};
var _default = exports.default = ImageViewer;